import moment from 'moment';

// The helpers that the Components use, copied verbatim from src/util/Utilities.ts
// of the rates app. The app keeps its own class; only these six live here.
class Utilities {

	public static classNames(...classes: (false | null | undefined | string)[]) {
		return classes.filter(Boolean).join(' ');
	}

	public static NVL = (value: boolean | undefined, property: string, def = '', prefix = '') => {
		return value ? prefix + property : def;
	};

	public static formatDouble = (num: number | undefined | null, minimumFractionDigits = 2, defaultValue = '0', alwaysShowFractionDigits = false): string => {
		if (!num) return defaultValue;
		const rounded = Math.round(num * Math.pow(10, minimumFractionDigits)) / Math.pow(10, minimumFractionDigits);
		const isWholeNumber = rounded % 1 === 0;
		return rounded.toLocaleString('en-US', { 
			minimumFractionDigits: isWholeNumber && !alwaysShowFractionDigits ? 0 : minimumFractionDigits,
			maximumFractionDigits: minimumFractionDigits 
		});
	};

	public static formatDate = (date: Date, format = 'yyyy-MM-DD') => {
		return moment(date).format(format);
	};

	public static formatISODate = (date: Date) => {
		return Utilities.formatDate(date, 'yyyy-MM-DD');
	};

	public static parseISODate = (date: Date) => {
		return moment(date, 'yyyy-MM-DD').toDate();
	};
}

export default Utilities;
